import { bunja } from 'bunja';
import { atomWithDefault } from 'jotai/utils';

import { abTestBunja } from '@flipster/features/src/shared/ab-test';

export const pendingPositionTableBunja = bunja(() => {
  const { getVariantAtom } = bunja.use(abTestBunja);
  const { variantAtom } = getVariantAtom('25q4-spot-limit-order');
  const pendingPositionTypeAtom = atomWithDefault<'limit' | 'trigger'>((get) => {
    const isLimitOrderEnabled = get(variantAtom) === 'on';
    return isLimitOrderEnabled ? 'limit' : 'trigger';
  });

  return { pendingPositionTypeAtom };
});
pendingPositionTableBunja.debugLabel = 'pendingPositionTableBunja';
